<template>
<div>
<el-card>
  <div slot="header" class="clearfix">
    <span style="color: #409EFF">商家详情</span>
  </div>
  <div>
    <el-row :gutter="0" style="border-bottom: 1px solid #44b1eb;text-align: center;">
      <el-col :span="24">
        <span style="color: #1F9FFF;width: 100%;text-align: center;">店铺信息</span>
      </el-col>
    </el-row>
    <el-row :gutter="0" style="margin-top: 15px;">
      <el-col :span="24">
        <el-table :data="shopTable" border default-expand-all stripe
                  :header-cell-style="{'text-align':'center'}"
                  :cell-style="{'text-align':'center'}"
                  style="width: 100%;margin-bottom: 20px;">
          <el-table-column prop="shopName" label="店铺名称" />
          <el-table-column prop="shopUsername" label="掌柜名" />
          <el-table-column prop="shopType" label="店铺类型" />
          <el-table-column prop="reviewStatus" label="店铺状态" />
          <el-table-column prop="shopGroup" label="店铺组(商家)" />
          <el-table-column prop="rebuyDays" label="复购天数(商家)" />
          <el-table-column prop="systemGroup" label="店铺组(系统)" />
          <el-table-column prop="sysRebuyDays" label="复购天数(系统)" />
          <el-table-column prop="createTime" label="添加时间" />
        </el-table>
      </el-col>
    </el-row>
    <el-row :gutter="0" style="border-bottom: 1px solid #44b1eb;text-align: center;margin-top: 15px;">
      <el-col :span="24">
        <span style="color: #1F9FFF;width: 100%;text-align: center;">商家信息</span>
      </el-col>
    </el-row>
    <div style="text-align: center;color: #2c2c2c;font-size: small;margin-top: 15px;">
      <el-row :gutter="20">
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">商家编号</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{getStrEndWithNumbers(businessInfo.userId)}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">联系手机</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.userPhone}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">联系QQ</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.userQq}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">联系微信</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.userWechat}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">地区</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.addressArea}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">账户余额</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left; color:red;">{{businessInfo.balanceMoney}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">冻结资金</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left;color: red;">{{businessInfo.freezeMoney}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">注册时间</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.registerTime}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">最大店铺数</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.maxShops}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">店铺数量</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">{{businessInfo.usedShops}}</div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">是否可以发布任务</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">
            <el-radio-group v-model="isReleaseTask">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
            <el-button plain type="primary" size="mini" style="margin-left: 1%;" @click="updateUserEnable">保存发布任务状态</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" >
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: right">状态</div>
        </el-col>
        <el-col :span="12">
          <div style="width: 100%;line-height: 33px; text-align: left">
            <el-select v-model="reviewStatus" clearable placeholder="请选择" size="mini" style="width: 20%;">
              <el-option
                  v-for="item in allReviewStatus"
                  :key="item.statusCode"
                  :label="item.statusName"
                  :value="item.statusCode"
              >
              </el-option>
            </el-select>
            <el-button plain type="primary" size="mini" style="margin-left: 1%;" @click="changeUserStatus">保存状态</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</el-card>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import {
  getStoresDetail,
  updateBusinessOrderEnable,
  updateUserStatus
} from "../../api/b2cbusiness/storelist";
import {getStrEndWithNumbers} from "../../lib/utils";

export default {
name: "B2cStoreItemDetail",
  mixins:[MixinCUD],
  data() {
    return {
      shopTable:[],
      isReleaseTask:true,
      businessInfo:{},
      reviewStatus:'202111300001',
      allReviewStatus:[
        {
          statusCode:'202111300001',
          statusName:"未审核"
        },
        {
          statusCode:'202111300003',
          statusName:"审核通过"
        },
        {
          statusCode:'202111300002',
          statusName:"审核未通过"
        },
        {
          statusCode:'202111300004',
          statusName:"账号锁定"
        },
      ]
    }
  },
  mounted() {
    console.log(this.$route.query)
    getStoresDetail({userId:this.$route.query.userId}).then(res=>{
      console.log(res.data)
      if (res.success){
        this.businessInfo = res.data;
        this.shopTable = res.data.b2cShops;
        this.isReleaseTask = this.businessInfo.businessOrderEnabled;
        this.reviewStatus = this.businessInfo.status;
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  methods:{
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    updateUserEnable(){
      updateBusinessOrderEnable({userId:this.businessInfo.userId, usedEnable:this.isReleaseTask}).then(res=>{
        if (res.success){
          this.$message.success("更新数据成功！");
          this.getData()
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    changeUserStatus(){
      updateUserStatus({userId:this.businessInfo.userId, status:this.reviewStatus}).then(
          res=>{
            if (res.success){
              this.$message.success("更新数据成功！");
              this.getData();
            }
          }
      ).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData(){
      getStoresDetail({userId:this.$route.query.userId}).then(res=>{
        console.log(res.data)
        if (res.success){
          this.businessInfo = res.data;
          this.shopTable = res.data.b2cShops;
          this.isReleaseTask = this.businessInfo.businessOrderEnabled
          this.reviewStatus = this.businessInfo.status;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style scoped>

</style>
